import {
  Box,
  Button,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { ReactElement, ReactNode } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import { BsPlus } from "react-icons/bs";

export type CMSectionMultipleCardAddableProps = {
  editMode?: "editable" | "disabled" | "readOnly";
  /**
   * 表示項目
   */
  children?: ReactNode;

  // ボタン設定
  buttonIcon?: ReactElement;
  buttonLabel?: string;

  /**
   * ボタンイベントを呼び出し元コンポーネントに通知する
   */
  onAddSection?: () => void;
} & ComponentStyleProps;

/**
 * 複数カード追加可能セクションを表示するコンポーネント
 */
export const CMSectionMultipleCardAddable = ({
  editMode,
  children,
  buttonIcon = <BsPlus />,
  buttonLabel,
  onAddSection,

  sx,
  ...rest
}: CMSectionMultipleCardAddableProps) => {
  const styles = useMultiStyleConfig("CMSectionMultipleCardAddableStyles");

  return (
    <Box sx={{ ...styles.container, ...sx }} {...rest}>
      {/*表示エリア*/}
      <Box sx={styles.cardArea}>{children}</Box>
      {/*追加ボタン*/}
      {editMode === "editable" && (
        <Button
          colorScheme={"teal"}
          size={"sx"}
          leftIcon={buttonIcon}
          onClick={onAddSection}
          sx={styles.addButton}
        >
          <Text sx={styles.addButtonLabel}>{buttonLabel}</Text>
        </Button>
      )}
    </Box>
  );
};

export const CMSectionMultipleCardAddableStyles: ComponentMultiStyleConfig = {
  parts: ["container", "cardArea", "addButton", "addButtonLabel"],

  baseStyle: {
    container: {
      display: "flex",
      flexDirection: "column",
    },
    cardArea: {
      display: "flex",
      flexDirection: "column",
    },
    addButton: {
      w: "fit-content",
      p: "2px 8px 2px 2px",
      mt: "8px",
    },
    addButtonLabel: {
      fontSize: "12px",
    },
  },
};
